"use client";

import Image from "next/image";
import { useMemo } from "react";

export default function MaskedImage({ 
  src, 
  alt, 
  size = "sm", 
  maskSrc,
  className = "",
  priority = false,
}) {

  const MASK_MAP = {

    sm: "/image/mask-sm.svg",
    
    md: "/image/mask-md.svg",
    
    lg: "/image/mask-lg.svg",
    
    xl: "/image/mask-xl.svg",
    
    };

  const currentMask = maskSrc || MASK_MAP[size] || MASK_MAP.sm;

  const maskStyles = useMemo(() => ({
    WebkitMaskImage: `url(${currentMask})`,
    maskImage: `url(${currentMask})`,
    WebkitMaskRepeat: "no-repeat",
    maskRepeat: "no-repeat",
    WebkitMaskSize: "contain",
    maskSize: "contain",
    WebkitMaskPosition: "center",
    maskPosition: "center",
  }), [currentMask]);

  return (
    <div 
      className={`relative overflow-hidden aspect-square bg-gray-200  ${className}`}
      style={maskStyles} 
    >
      {src && (
        <Image
          src={src}
          alt={alt}
          fill
          priority={priority}
          fetchPriority={priority ? "high" : "auto"}
          quality={70}
          className="object-cover"
          sizes="(max-width: 768px) 100vw, 50vw"
        />
      )}
    </div>
  );
}
